import styled from "styled-components"

export const DateTimeWrapper = styled.div`
 .react-datepicker__input-container{
        input{
            height: 40px !important;
            padding: 4px 12px;
            border: 1px solid #9B9696;
            border-radius: 4px;
            width: 100%;
            cursor: pointer;
        }
    }
`
